import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl, Link } from "gatsby-plugin-intl";
import { Container, Image, Header, Button, Icon } from "semantic-ui-react";
import HardLink from "./HardLink";
import logo from "../assets/logo.png";

const HomepageHeading = ({ intl }, { isMobile }) => {
  return (
    <Container text>
      <Header
        as="h1"
        inverted
        style={{
          fontSize: isMobile ? "2em" : "4em",
          fontWeight: "normal",
          marginBottom: 0,
          marginTop: isMobile ? "0.75em" : "1.5em",
        }}
      >
        <Image
          size={isMobile ? "tiny" : "massive"}
          src={logo}
          alt="logo"
          style={{ marginBottom: isMobile ? 8 : 15, marginRight: 10 }}
        />
        <FormattedMessage id="overview_jumbotron_h1" />
      </Header>
      <Header
        as="h2"
        content={intl.formatMessage({ id: "overview_jumbotron_h2" })}
        inverted
        color="yellow"
        style={{
          fontSize: isMobile ? "1.2em" : "1.7em",
          fontWeight: "normal",
          marginTop: isMobile ? "0.75em" : "1.5em",
        }}
      />
      <p style={{ marginBottom: "2em" }}>
        <FormattedMessage id="overview_jumbotron_p1" />
      </p>
      {intl.locale === "ko" && (
        <Header
          as="h4"
          color="orange"
          content={intl.formatMessage({ id: "overview_jumbotron_p2" })}
        />
      )}
      {intl.locale !== "ko" && (
        <Button
          color="blue"
          icon="download"
          inverted
          size={isMobile ? "big" : "huge"}
          as={Link}
          name="download"
          to="/download"
          fluid={isMobile}
          style={{ margin: 5 }}
          content={intl.formatMessage({ id: "nav_download" })}
        />
      )}
      {intl.locale !== "ko" && (
        <Button
          color="orange"
          inverted
          icon="cart"
          size={isMobile ? "big" : "huge"}
          as={HardLink}
          name="buy"
          to="/buy"
          fluid={isMobile}
          style={{ margin: 5 }}
          content={intl.formatMessage({ id: "nav_buy" })}
        />
      )}
      <p
        style={{
          marginTop: "1em",
          fontSize: "0.9em",
        }}
      >
        <Icon name="windows" /> <FormattedMessage id="text_winavailable" />
      </p>
    </Container>
  );
};

HomepageHeading.contextTypes = {
  isMobile: PropTypes.bool,
};

export default injectIntl(HomepageHeading);
